import { TRUSTEE_EWALLET_REF_PREFIX } from "helpers/withdrawalDepositConstants";

/** Standard platform record-id format (e.g. primary keys). */
export const INTERNAL_RECORD_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Long opaque ids (Salesforce-style keys, etc.). */
export const OPAQUE_RECORD_ID_PATTERN = /^[a-z0-9_-]{20,}$/i;

/** Embedded record id inside a longer display string. */
export const INTERNAL_RECORD_ID_IN_TEXT_PATTERN =
  /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i;

export function isInternalRecordId(value?: string | null): boolean {
  const candidate = (value ?? "").trim();
  if (!candidate) {
    return false;
  }
  return (
    INTERNAL_RECORD_ID_PATTERN.test(candidate) ||
    OPAQUE_RECORD_ID_PATTERN.test(candidate)
  );
}

export function internalRecordIdAppearsInText(value?: string | null): boolean {
  const candidate = (value ?? "").trim();
  if (!candidate) {
    return false;
  }
  return INTERNAL_RECORD_ID_IN_TEXT_PATTERN.test(candidate);
}

/** True when value is an internal wallet id, not a trustee organisation name. */
export function isInternalWalletIdentifier(value?: string | null): boolean {
  const raw = (value ?? "").trim();
  if (!raw) {
    return false;
  }
  if (isInternalRecordId(raw)) {
    return true;
  }
  if (/^\d+$/.test(raw)) {
    return true;
  }
  if (raw.toUpperCase().startsWith(TRUSTEE_EWALLET_REF_PREFIX)) {
    return true;
  }
  return false;
}
